import { render, staticRenderFns } from "./kunden-dubletten-confirmation-view.vue?vue&type=template&id=6e174b6f"
import script from "./kunden-dubletten-confirmation-view.vue?vue&type=script&lang=js"
export * from "./kunden-dubletten-confirmation-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports